<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <b-card>
      <div slot="header">
        Permohonan Pelunasan
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title="Print data pelunasan" :disabled="savedisabled"
            @click="save(true)">
            <i class="fa fa-print"></i>
            <span v-if="!$route.params.pelunasankey">
              {{ $t("printsave") }}</span>
            <span v-else> {{ $t("print") }}</span>
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title="Simpan data pelunasan" @click="save()"
            :disabled="savedisabled">
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title="Print data pelunasan." :disabled="savedisabled"
            @click="save(true)">
            <i class="fa fa-print"></i>
            <span v-if="!$route.params.pelunasankey">
              {{ $t("printsave") }}</span>
            <span v-else> {{ $t("print") }}</span>
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title="Simpan data pelunasan." :disabled="savedisabled"
            @click="save()">
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input readonly v-model="model.no_kontrak" @keyup.13.native="lkuPinjamanShow = true"
                  :state="!$v.frmdt.pinjamankey.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px">Tgl.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tgl_kontrak" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <span class="pt-2">
                  <a :href="viewaggrementcard()" target="_blank"> {{ model.no_agreement }}</a>
                </span>
              </b-input-group>
            </b-col>
            <b-col lg="5" style="display: flex;justify-content: left;align-items: center;">

              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px">Model Pinjaman</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.model_pinjaman" disabled></b-form-input>
              </b-input-group>
              <!-- <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a> -->
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.pinjaman_uraian" disabled></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman == 'PAB' || model.model_pinjaman == 'PB'">
                <label style="width: 140px">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width: 140px">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number v-if="model.model_pinjaman == 'PAB' || model.model_pinjaman == 'PB'"
                class="form-control text-right" v-model="model.principal" :precision="2" disabled></my-number>
              <my-number v-else class="form-control text-right" v-model="model.principal" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
            model.matauang
          }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.tenor" :precision="0" disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.bungaod_tarifthn" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman == 'PAB' || model.model_pinjaman == 'PB'">
              <b-input-group-prepend>
                <label style="width: 140px">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.installment_amount" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
            model.matauang
          }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.bungaod_tarifthn" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 150px">Pelunasan Secara</label>
            </b-input-group-prepend>
            <b-form-radio-group v-model="frmdt.tipepelunasan" :options="optionsPelunasan" class="mb-3 mt-1"
              value-field="item" text-field="name"></b-form-radio-group>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl Pelunasan</label>
            </b-input-group-prepend>
            <b-form-input type="date" v-model="frmdt.tglmulaipelunasan" v-if="ifBertahap"></b-form-input>
            <!-- :state="!$v.frmdt.tglmulaipelunasan.$error" -->
            <b-input-group-prepend v-if="ifBertahap">
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input type="date" v-model="frmdt.tglpelunasan" :state="!$v.frmdt.tglpelunasan.$error"
              class="mr-2"></b-form-input>
            <!-- :min="new Date | moment('YYYY-MM-DD')" -->
            <b-button variant="danger" v-b-tooltip.hover title="Hitung biaya pelunasan" @click="calculate">
              <i class="fa fa-calculator"></i> Calc.
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col lg="5">
          <h5>
            Posisi tunggakan sampai hari ini {{ model.hariini | moment("DD-MMM-YYYY") }}
          </h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlprincipalcurrent" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Bunga</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlinterestcurrent" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Denda</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttllatechargecurrent" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Pemb. (Pokok+Bunga)</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number :value="frmdt.ttl_paid_interest+frmdt.ttl_paid_principal" :precision="2" class="text-right" disabled></my-number>
          </b-input-group>
          
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col lg="5">
          <h5>
            Posisi tunggakan sampai maturity {{ this.model.duedate | moment("DD-MMM-YYYY") }}
          </h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number v-model="frmdt.ttlosprincipal_untilmaturity" :precision="2" class="text-right"
              disabled></my-number>
          </b-input-group>
        </b-col>
      </b-row>

      <!-- else PAB & PB -->
      <!-- <b-row class="mt-3" v-else>
        <b-col lg="5">
          <h5>
            Posisi tunggakan sampai hari ini {{ frmdt.hariini | moment("DD-MMM-YYYY") }}
          </h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Saldo Pokok</label>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlprincipalcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Bunga & OD</label>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterestcurrent"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row> -->
      <hr />

      <div class="mt-3">
        <b-row>
          <b-col lg="12">
            <h5>Posisi tunggakan sampai tgl pelunasan {{ frmdt.tglpelunasan | moment("DD-MMM-YYYY") }}</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3">
            <h5>Keterangan</h5>
          </b-col>
          <b-col lg="3">
            <h5>Amount Awal</h5>
          </b-col>
          <b-col lg="3">
            <h5>Diskon</h5>
          </b-col>
          <b-col lg="3">
            <h5>Net Amount</h5>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>OS Pokok Belum JT</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ospokokbelumjt" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.diskon_ospokokbelumjt_amount" :precision="2" class="text-right"
                disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.net_ospokokbelumjt" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>Tunggakan Angsuran</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ttlangsuran" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.diskon_angsuran_amount" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.net_ttlangsuran" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>Bunga Berjalan</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ttlinterest" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.diskon_interest_amount" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.net_ttlinterest" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="2">
            <label>Denda Angsuran</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ttllatecharge" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>

          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.diskon_latecharge_amount" :precision="2" class="text-right"
                disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.net_ttllatecharge" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </b-col>
        </b-row>


        <b-row>
          <b-col lg="2">
            <label>Denda Lainnya</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.dendalain" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>

          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.diskon_dendalain_amount" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.net_dendalain" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row v-if="frmdt.pinalty_rate > 0">
          <b-col lg="2">
            <label>{{ this.frmdt.pinalty_rate }}% Pinalty</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.pinalty" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.diskon_pinalty_amount" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.net_pinalty" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="2">
            <h6>Total</h6>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ttlpayment_awal" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ttlpayment_diskon" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ttlpayment" :precision="2" class="text-right" style="padding-right: 11px"
                disabled></my-number>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col offset="5" lg="3">
            <label class="mt-2 text-right">Prepaid</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.prepaid" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col offset="5" lg="3">
            <label class="mt-2 text-right">Jumlah yang harus masih dibayar</label>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="frmdt.ttlmustpay" :precision="2" class="text-right" disabled></my-number>
            </b-input-group>
          </b-col>
        </b-row>

      </div>

      <!-- else PAB & PB -->
      <!-- <b-row class="mt-3" v-else>
        <b-col lg="5">
          <h5>
            Posisi sampai tgl pelunasan
            {{ frmdt.tglpelunasan | moment("DD-MMM-YYYY") }}
          </h5>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Saldo Pokok</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlprincipal"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="width: 160px !important">Total Bunga & OD</label>
            </b-input-group-prepend>
            <b-input-group-prepend style="height: 35px">
              <span class="input-group-text">IDR</span>
            </b-input-group-prepend>
            <my-number
              v-model="frmdt.ttlinterest"
              :precision="2"
              class="text-right"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row> -->

      <hr />
      <b-row>
        <b-col lg="6">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tanggal Surat</label>
                </b-input-group-prepend>
                <b-input type="date" v-model="frmdt.tglsurat" />
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nomor Surat</label>
                </b-input-group-prepend>
                <b-form-input v-if="this.$route.params.pelunasankey" v-model="frmdt.nosurat"></b-form-input>
                <b-form-input v-else v-model="frmdt.nosurat" :state="!$v.frmdt.nosurat.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Kepada</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.kepada"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Perihal</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.perihal"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Lokasi / LDSK</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdt.lokasiLDSK1"></b-form-input>
            <b-form-input v-model="frmdt.lokasiLDSK2"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Kronologis</label>
            </b-input-group-prepend>
            <b-form-textarea v-model="frmdt.kronologis" placeholder="" rows="5" max-rows="10"></b-form-textarea>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>CC</label>
            </b-input-group-prepend>
            <b-form-textarea v-model="frmdt.cc" placeholder="" rows="4" max-rows="6"></b-form-textarea>
          </b-input-group>
          <!-- :state="!$v.frmdt.cc.$error" -->
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="lkuPinjamanShow" size="lg" :hide-footer="true" title="Daftar Pinjaman" :centered="true">
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import pelunasan from "../../apis/pelunasanpinjaman";
import jaminan from "../../apis/agunankredit";

// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman, Loading },
  mixins: [validationMixin],
  validations: {
    frmdt: {
      pinjamankey: { required },
      tglpelunasan: { required },
      nosurat: {
        required: false
        // function () {
        //   if (this.saving) {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // }
      },
    },
  },
  data() {
    return {
      validationError: {
        pinjamankey: { required: "Pilih Fasilitas/Debitur" },
        tglpelunasan: { required: "Masukkan Tanggal" },
        nosurat: { required: "Masukkan No Surat" },
      },
      showReport: false,
      reportUrl: null,
      isLoading: false,
      saving: false,
      text: "",
      savedisabled: false,
      isBusy: false,
      isPelunasankey: false,
      model: { model_pinjaman: '', no_agreement: '-' },
      frmdt: {
        statussp: null,
        pinjamankey: "",
        tglmulaipelunasan: moment().format("YYYY-MM-DD"),
        tglpelunasan: moment().format("YYYY-MM-DD"),
        hariini: moment().format("YYYY-MM-DD"),
        //
        tglsurat: moment().format("YYYY-MM-DD"),
        type_memo:'normal',
        nosurat: "",
        kepada: "Komite Kredit",
        perihal: "Persetujuan Pelunasan Dipercepat",
        lokasiLDSK1: "",
        lokasiLDSK2: "",
        kronologis: "",
        cc: "- Loan Admin \n- Audit",
        ttd1_diajukan_nama: "",
        ttd1_diajukan_jabatan: "",
        ttd1_mengetahui_nama: "",
        ttd1_mengetahui_jabatan: "",
        ttd1_disetujui_nama: "",
        ttd1_disetujui_jabatan: "",
        // uraian: "",
        ttlinstalmentcurrent: 0,
        ttllatechargecurrent: 0,
        ttlprincipalcurrent: 0,
        ttlinterestcurrent: 0,
        ttlinstalment: 0,
        ttlprincipal: 0,
        ttllatecharge: 0,
        ttlinterest: 0,
        ttlangsuran: 0,
        OS_pokok_due: 0,
        OS_bunga_due: 0,
        ospokokbelumjt: 0,
        dendalain: 0,
        pinalty: 0,
        pinalty_rate: 0, // default red dragon 8
        // diskon_percent: 0,
        // diskon_amount: 0,

        diskon_principal_percent: 0,
        diskon_principal_amount: 0,
        diskon_interest_percent: 0,
        diskon_interest_amount: 0,

        diskon_angsuran_percent: 0,
        diskon_angsuran_amount: 0,
        diskon_angsuran_principle_amt: 0,
        diskon_angsuran_interest_amt: 0,

        diskon_latecharge_percent: 0,
        diskon_latecharge_amount: 0,

        diskon_ospokokbelumjt_percent: 0,
        diskon_ospokokbelumjt_amount: 0,
        diskon_dendalain_percent: 0,
        diskon_dendalain_amount: 0,
        diskon_pinalty_percent: 0,
        diskon_pinalty_amount: 0,

        net_ttlprincipal: 0,
        net_ttlinterest: 0,

        net_ttlangsuran: 0,

        net_ttllatecharge: 0,

        net_ospokokbelumjt: 0,
        net_dendalain: 0,
        net_pinalty: 0,

        ttlpayment_awal: 0,
        ttlpayment_diskon: 0,
        ttlpayment: 0,
        prepaid: 0,
        ttlmustpay: 0,
        tipepelunasan: "Normal",
        angsuran_dari: 0, angsuran_ke: 0,
        ttl_paid_interest: 0,
        ttl_paid_lateCharge: 0,
        ttl_paid_principal: 0
      },

      ifCalculated: false,
      lkuPinjamanShow: false,
      optionsPelunasan: [
        { item: "Normal", name: "Normal" },
        { item: "Bertahap", name: "Bertahap" },
      ],
    };
  },
  computed: {
    invalidFrmDt() {
      this.$v.frmdt.$touch();
      console.log('this.$v.frmdt', this.$v.frmdt.$params)
      console.log('this.$v.frmdt', this.$v.frmdt)
      return this.$v.frmdt.$invalid;
    },
    canSave() {
      return this.ifCalculated;
    },
    ifBertahap() {
      return this.frmdt.tipepelunasan == "Bertahap" ? true : false;
    },
  },
  watch: {
    "frmdt.net_ospokokbelumjt"(val) {
      const diskon_ospokokbelumjt_amount = this.frmdt.ospokokbelumjt - val;
      this.frmdt.diskon_ospokokbelumjt_amount = diskon_ospokokbelumjt_amount
      this.calcpaymn();
    },
    "frmdt.net_ttlangsuran"(val) {
      const diskon_angsuran_amount = this.frmdt.ttlangsuran - val;
      this.frmdt.diskon_angsuran_amount = diskon_angsuran_amount
      this.calcpaymn();
    },
    "frmdt.net_ttlinterest"(val) {
      const diskon_interest_amount = this.frmdt.ttlinterest - val;
      this.frmdt.diskon_interest_amount = diskon_interest_amount
      this.calcpaymn();
    },
    "frmdt.net_ttllatecharge"(val) {
      const diskon_latecharge_amount = this.frmdt.ttllatecharge - val;
      this.frmdt.diskon_latecharge_amount = diskon_latecharge_amount
      this.calcpaymn();
    },
    "frmdt.net_dendalain"(val) {
      const diskon_dendalain_amount = this.frmdt.dendalain - val;
      this.frmdt.diskon_dendalain_amount = diskon_dendalain_amount
      this.calcpaymn();
    },
    "frmdt.net_pinalty"(val) {
      const diskon_pinalty_amount = this.frmdt.pinalty - val;
      this.frmdt.diskon_pinalty_amount = diskon_pinalty_amount
      this.calcpaymn();
    },
  },
  created: async function () {
    this.model.model_pinjaman = "";
    if (this.$route.params.pelunasankey) {
      toastr.info("Loading Payment Detail, please wait");
      this.isPelunasankey = true;
      try {
        const res = await pelunasan.detail(this.$route.params.pelunasankey);
        for (const key in res) {
          this.model[key] = res[key];
          this.frmdt[key] = res[key];
        }

        this.model.tgl_kontrak = this.model.tgl_kontrak
          ? moment(this.model.tgl_kontrak).format("DD-MMM-YYYY")
          : "";
        this.frmdt.tglpelunasan = this.frmdt.tglpelunasan
          ? moment(this.frmdt.tglpelunasan).format("YYYY-MM-DD")
          : "";
        this.frmdt.tglmulaipelunasan = this.frmdt.tglmulaipelunasan
          ? moment(this.frmdt.tglmulaipelunasan).format("YYYY-MM-DD")
          : "";

        this.frmdt.tglsurat = this.frmdt.tglsurat
          ? moment(this.frmdt.tglsurat).format("YYYY-MM-DD")
          : "";

        this.frmdt.tipepelunasan = res.tipepelunasan;
        this.frmdt.nilaijaminan = res.nilaijaminan;

        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
      this.frmdt.ttd1_diajukan_nama = this.model.ttd1_diajukan_nama ? this.model.ttd1_diajukan_nama : "-"; //Diajukan Oleh
      this.frmdt.ttd1_diajukan_jabatan = this.model.ttd1_diajukan_jabatan ? this.model.ttd1_diajukan_jabatan : "-"; //Diajukan Oleh

      if(this.$route.params.type_memo =='banding'){
        // this.frmdt.nosurat='';
        this.frmdt.pelunasankey='';
        this.frmdt.referencekey=this.$route.params.pelunasankey;
        this.frmdt.tglsurat = moment().format("YYYY-MM-DD");
        this.frmdt.type_memo = this.$route.params.type_memo;
        this.calculate()
      }

    } else {
      this.frmdt.ttd1_diajukan_nama = this.model.ttd1_diajukan_nama ? this.model.ttd1_diajukan_nama : this.$store.state.user.full_name; //Diajukan Oleh
      this.frmdt.ttd1_diajukan_jabatan = this.model.ttd1_diajukan_jabatan ? this.model.ttd1_diajukan_jabatan : this.$store.state.user.jabatan; //Diajukan Oleh
    }
    // const dataWF = await pelunasan.getworkflow();
    // this.frmdt.ttd1_mengetahui_nama = this.model.ttd1_mengetahui_nama ? this.model.ttd1_mengetahui_nama : dataWF[0] ? dataWF[0].full_name : ''; //Mengetahui
    // this.frmdt.ttd1_mengetahui_jabatan = this.model.ttd1_mengetahui_jabatan ? this.model.ttd1_mengetahui_jabatan : dataWF[0] ? dataWF[0].jabatan : ''; //Mengetahui
    // this.frmdt.ttd1_disetujui_nama = this.model.ttd1_disetujui_nama ? this.model.ttd1_disetujui_nama : dataWF[1] ? dataWF[1].full_name : ''; //Disetujui Oleh
    // this.frmdt.ttd1_disetujui_jabatan = this.model.ttd1_disetujui_jabatan ? this.model.ttd1_disetujui_jabatan : dataWF[1] ? dataWF[1].jabatan : ''; //Disetujui Oleh
  },
  methods: {
    async onSelectLkuPinjaman(_selected) {
      this.model.model_pinjaman = _selected.model_pinjaman;
      const dtBlock = await pelunasan.detailblacklistbypinjamankey(_selected.pinjamankey);
      if (dtBlock) {
        if (dtBlock.tipepelunasan == "Normal,Bertahap") {
          toastr.warn(`Pinjaman Ini tidak dapat diajukan memo.`, "INFO", "5000");
          this.savedisabled = true;
        } else {
          const tipeBlockArr = (dtBlock.tipepelunasan).split(',');
          let optionsPelunasan = this.optionsPelunasan;
          tipeBlockArr.map((dt) => {
            let findIndex = optionsPelunasan.findIndex(x => x.item == dt);
            optionsPelunasan.splice(findIndex, 1);
          });
          this.optionsPelunasan = optionsPelunasan;
        }
      }


      if ((_selected.pelunasankey || '') != '') {
        toastr.warn(`Pinjaman sudah memiliki memo pelunasan. No memo : ${_selected.nosurat}`, "INFO", "5000");
      } else {
        this.resetCalc();
        this.frmdt.pinjamankey = _selected.pinjamankey;
        this.frmdt.nasabahkey = _selected.nasabahkey;
        this.frmdt.pinalty_rate = _selected.pinalty_rate || 0; //default 8% pinalty
        for (const key in _selected) {
          this.model[key] = _selected[key];
        }

        this.model.tgl_kontrak = _selected.tgl_kontrak
          ? moment(_selected.tgl_kontrak).format("DD-MM-YYYY")
          : "";
        this.model.pinjaman_uraian = _selected.uraian;
        this.model.ttllatecharge = 0;
        this.frmdt.lokasiLDSK1 = _selected.branch;
        this.frmdt.lokasiLDSK2 = _selected.LDSK;
        const getJaminan = await jaminan.getjaminan(_selected.pinjamankey);
        this.frmdt.nilaijaminan = getJaminan[0].nilaijaminan;
      }


      this.frmdt.ttl_paid_interest = _selected.cumulative_payment_interest_after_cessie;
      this.frmdt.ttl_paid_lateCharge = _selected.cumulative_payment_latecharge_after_cessie;
      this.frmdt.ttl_paid_principal = _selected.cumulative_payment_principal_after_cessie;

      /*  let OS_Interest_Amount = _selected.interest_outstand - _selected.interest_outstand_undue;
       if(OS_Interest_Amount<0) OS_Interest_Amount =0
 
       let ttlprincipalcurrent = _selected.principal_outstand -_selected.principal_outstand_undue ;
       if(ttlprincipalcurrent < 0 ) ttlprincipalcurrent = 0
 
 
       let ttlangsuran =OS_Interest_Amount+ttlprincipalcurrent;
 
       this.frmdt.ttlinstalmentcurrent = ttlangsuran;
       this.frmdt.ttlprincipalcurrent = ttlprincipalcurrent;
       this.frmdt.ttlinterestcurrent = OS_Interest_Amount;
       // this.frmdt.ttllatechargecurrent = bbnPinjamanCurr.ttllatecharge;
       this.frmdt.ttlosprincipal_untilmaturity = _selected.principal_outstand; */

      this.lkuPinjamanShow = false;
    },
    async calculate() {
      try {
        this.saving = false;
        if (this.invalidFrmDt) {
          // console.log("validation : ", this.$v.issuedLinesObj);
          // console.log("model obj : ", this.issuedLinesObj);
          for (var key in this.$v.frmdt.$params) {
            if (this.$v.frmdt[key].$error || this.$v.frmdt[key].$anyError) {
              toastr.error(this.validationError[key].required, "ERROR MESSAGE");
              break;
            }
          }
        } else {
          this.isLoading = true;
          const data = await pinjaman.calcpelunasan(this.frmdt);
          const today = moment();
          const tglpelunasan = moment(this.frmdt.tglpelunasan);
          let diffDays = tglpelunasan.diff(today, "days");

          const {
            model_pinjaman,
            principal: pjmPrincipal,
            duedate: ODdate,
            bungaod_tarifthn,
            bunga_tarifthn,
          } = this.model;
          const { bbnPinjamanCurr, bbnPinjamanPelunasan } = data;
          // START total beban sampai hari ini
          this.frmdt.ttlinstalmentcurrent = bbnPinjamanCurr.ttlangsuran;
          this.frmdt.ttlprincipalcurrent = bbnPinjamanCurr.OS_Principal_Amount;
          this.frmdt.ttlinterestcurrent = bbnPinjamanCurr.OS_Interest_Amount;
          this.frmdt.ttllatechargecurrent = bbnPinjamanCurr.ttllatecharge;
          this.frmdt.cessie_etm = bbnPinjamanCurr.cessie_etm;
          this.frmdt.ttl_paid_interest = isFinite(bbnPinjamanCurr.sum_paid_bunga)?bbnPinjamanCurr.sum_paid_bunga:0;
          this.frmdt.ttl_paid_lateCharge = isFinite(bbnPinjamanCurr.sum_paid_denda)?bbnPinjamanCurr.sum_paid_denda:0;
          this.frmdt.ttl_paid_principal = isFinite(bbnPinjamanCurr.sum_paid_pokok)?bbnPinjamanCurr.sum_paid_pokok:0;

          this.frmdt.ttlosprincipal_untilmaturity = bbnPinjamanPelunasan.OS_Principal_Amount;
          // END

          /*  if (model_pinjaman == "PRK") {
             // current
             this.frmdt.ttlprincipalcurrent = pjmPrincipal;
             this.frmdt.ttlinterestcurrent =
               bbnPinjamanCurr.sum_bungahrian_interest;
             // sampai pelunasan
             this.frmdt.ttlprincipal = pjmPrincipal;
             this.frmdt.ttlinterest =
               bbnPinjamanPelunasan.sum_bungahrian_interest;
 
             this.frmdt.ttlangsuran =
               this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
             this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
             this.frmdt.dendalain = 0; //tanyakan kembali dendalain
             this.frmdt.pinalty = 0; //tanyakan kembali pinalty
 
             if (diffDays > 0) {
               diffDays += 1;
               let diffODDays = today.diff(moment(ODdate), "days");
               let ifOverDue = diffODDays > 0 ? true : false;
               const interestPrcnt = ifOverDue
                 ? bungaod_tarifthn
                 : bunga_tarifthn;
               const interest =
                 pjmPrincipal * (interestPrcnt / 100 / 360) * diffDays;
               this.frmdt.ttlinterest += interest;
             }
           } */

          if (model_pinjaman == "PAB" || model_pinjaman == "PB" || model_pinjaman == "PRK") {
            // START total beban sampai tanggal pelunasan
            this.frmdt.ttlinstalment =
              bbnPinjamanPelunasan.sum_angsrn_installment;
            this.frmdt.ttlprincipal = bbnPinjamanPelunasan.sum_angsrn_principal;

            this.frmdt.ttllatecharge =
              bbnPinjamanPelunasan.sum_nilai_dendahrian;
            this.frmdt.ttlinterest = bbnPinjamanPelunasan.sum_angsrn_interest;

            this.frmdt.ttlangsuran =
              this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
            this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
            this.frmdt.dendalain = bbnPinjamanPelunasan.dendalain;
            this.frmdt.pinalty = 0;

            // END

            // START HITUNG ULANG DENDA SAMPAI TANGGAL PELUNASAN
            // if (diffDays > 0) {
            //   diffDays += 1;
            //   const ttlDendaSmpaiLns =
            //     diffDays *
            //     (bbnPinjamanCurr.sum_angsrn_principal *
            //       (this.model.denda_tarifhri / 100));
            //   this.frmdt.ttllatecharge += ttlDendaSmpaiLns;
            // }
            // END
          }

          for (const key in bbnPinjamanPelunasan) {
            this.frmdt[key] = bbnPinjamanPelunasan[key];
          }
          this.calcpaymn();
          this.ifCalculated = true;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    calcpaymn() {

      this.frmdt.net_ospokokbelumjt =
        (this.frmdt.ospokokbelumjt || 0) -
        this.frmdt.diskon_ospokokbelumjt_amount;

      this.frmdt.net_ttlprincipal =
        (this.frmdt.ttlprincipal || 0) - this.frmdt.diskon_principal_amount;

      this.frmdt.net_ttlinterest =
        (this.frmdt.ttlinterest || 0) - this.frmdt.diskon_interest_amount;

      this.frmdt.net_ttlangsuran =
        (this.frmdt.ttlangsuran || 0) - this.frmdt.diskon_angsuran_amount;

      this.frmdt.net_ttllatecharge =
        (this.frmdt.ttllatecharge || 0) - this.frmdt.diskon_latecharge_amount;

      this.frmdt.net_dendalain =
        (this.frmdt.dendalain || 0) - this.frmdt.diskon_dendalain_amount;
      this.frmdt.net_pinalty =
        (this.frmdt.pinalty || 0) - this.frmdt.diskon_pinalty_amount;

      this.frmdt.ttlpayment =
        parseFloat(this.frmdt.net_ttlangsuran) +
        parseFloat(this.frmdt.net_ttlinterest) +
        parseFloat(this.frmdt.net_ttllatecharge) +
        parseFloat(this.frmdt.net_ospokokbelumjt) +
        parseFloat(this.frmdt.net_dendalain) +
        parseFloat(this.frmdt.net_pinalty);

      this.frmdt.ttlpayment_awal =
        (parseFloat(this.frmdt.ttlangsuran) || 0) +
        (parseFloat(this.frmdt.ttlinterest) || 0) +
        (parseFloat(this.frmdt.ttllatecharge) || 0) +
        (parseFloat(this.frmdt.ospokokbelumjt) || 0) +
        (parseFloat(this.frmdt.dendalain) || 0) +
        (parseFloat(this.frmdt.pinalty) || 0);

      this.frmdt.ttlpayment_diskon =
        (parseFloat(this.frmdt.diskon_angsuran_amount) || 0) +
        (parseFloat(this.frmdt.diskon_interest_amount) || 0) +
        (parseFloat(this.frmdt.diskon_latecharge_amount) || 0) +
        (parseFloat(this.frmdt.diskon_ospokokbelumjt_amount) || 0) +
        (parseFloat(this.frmdt.diskon_dendalain_amount) || 0) +
        (parseFloat(this.frmdt.diskon_pinalty_amount) || 0);

      this.frmdt.ttlmustpay = this.frmdt.ttlpayment - this.frmdt.prepaid;
    },
    resetCalc() {
      this.frmdt.uraian = "";
      this.frmdt.ttlinstalmentcurrent = 0;
      this.frmdt.ttlprincipalcurrent = 0;
      this.frmdt.ttllatechargecurrent = 0;
      this.frmdt.ttlinterestcurrent = 0;
      this.frmdt.ttlinstalment = 0;
      this.frmdt.ttlprincipal = 0;
      this.frmdt.ttllatecharge = 0;
      this.frmdt.ttlinterest = 0;
      this.frmdt.ttlangsuran = 0;
      this.frmdt.ospokokbelumjt = 0;
      this.frmdt.dendalain = 0;
      this.frmdt.pinalty = 0;
      // this.frmdt.diskon_percent = 0;
      this.frmdt.diskon_principal_percent = 0;
      this.frmdt.diskon_interest_percent = 0;
      this.frmdt.diskon_angsuran_percent = 0;
      this.frmdt.diskon_latecharge_percent = 0;
      this.frmdt.diskon_ospokokbelumjt_percent = 0;
      this.frmdt.diskon_dendalain_percent = 0;
      this.frmdt.diskon_pinalty_percent = 0;
      //this.frmdt.diskon_amount = 0;
      this.frmdt.diskon_principal_amount = 0;
      this.frmdt.diskon_interest_amount = 0;
      this.frmdt.diskon_angsuran_amount = 0;
      this.frmdt.diskon_latecharge_amount = 0;
      this.frmdt.diskon_ospokokbelumjt_amount = 0;
      this.frmdt.diskon_dendalain_amount = 0;
      this.frmdt.diskon_pinalty_amount = 0;

      this.frmdt.net_ttlprincipal = 0;
      this.frmdt.net_ttlinterest = 0;
      this.frmdt.net_ttlangsuran = 0;
      this.frmdt.net_ttllatecharge = 0;
      this.frmdt.net_ospokokbelumjt = 0;
      this.frmdt.net_dendalain = 0;
      this.frmdt.net_pinalty = 0;
      this.frmdt.ttlpayment = 0;
      this.frmdt.prepaid = 0;
      this.frmdt.ttlmustpay = 0;
      this.ifCalculated = false;
    },
    async printPelunasanpdf() {
      try {
        this.isLoading = true;
        this.reportUrl = await pelunasan.printPDFMemoPelunasan(
          this.frmdt.pelunasankey
        );
        this.isLoading = false;
        this.showReport = true;
      } catch (error) {
        this.showReport = false;
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "loan.pelunasan" });
    },
    async save(printed = false) {
      this.saving = true
      if (this.invalidFrmDt) {
        for (var key in this.$v.frmdt.$params) {
          if (this.$v.frmdt[key].$error || this.$v.frmdt[key].$anyError) {
            toastr.error(this.validationError[key].required, "ERROR MESSAGE");
            break;
          }
        }
      } else {
        // if (this.frmdt.ttlpayment == 0) {
        //   this.stateTtlPay = false;
        //   toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        // } else {
        //disini cek api dulu, apakah nomor surat memo pelunasan sudah pernah ada sebelumnya!
        const dataNomorMemo = await pelunasan.ceknomorMemo(this.frmdt);
        if (!this.$route.params.pelunasankey && dataNomorMemo) {
          toastr.warn(`Memo pelunasan dengan nomor surat: ${dataNomorMemo.nosurat} sudah pernah dibuat sebelumnya. Silahkan cek kembali nomor surat!`, "INFO", "8000");
        } else {
          try {
            this.isLoading = true;
            await pelunasan.save(this.frmdt);
            this.isLoading = false;
            toastr.success("Data berhasil disimpan");
            if (printed) {
              this.printPelunasanpdf();
            }
            router.push({ name: "loan.pelunasan" });
          } catch (error) {
            this.isLoading = false;
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
        // }
      }
    },
    viewaggrementcard() {
      const url = router.resolve({ name: 'loan.agreementcardparams', params: { pinjamankey: this.model.pinjamankey } }).route.path;
      return `#` + url;
    },
  },
};
</script>
